import { Component } from 'react';

import FileUpload from '../../../components/file-upload';

import { AddButton } from '../../../components/buttons';

export default class QuestionTypeUploadDocuments extends Component {
    constructor(props) {
        super(props);

        this.state = {
            files: []
        }
    }

    componentDidMount() {
        let { params } = this.props;

        if (params.value !== null) {
            this.setState({ files: params.value })
        } else {
            this.addFile();
        }

        this.setError(params.value);
    }

    onComponentChange(e, index) {
        const { sectionId, blockId, question, onChange, getQuestionValue } = this.props;

        let value = getQuestionValue(sectionId, blockId, question.id);

        if (value == null) {
            value = [ e ];
        } else {
            value[index] = e;
        }

        this.setState({ files: value }, () => {

        })

        onChange({ value });
        this.setError(value);
    }

    setError(value) {
        const { question, addError } = this.props;

        if (value !== null) {
            let errors = []

            const atleastOne = value.filter(obj => Object.keys(obj).length > 0).length > 0;

            if (question.response_required) {
                if (value.length == 0 || !atleastOne) {
                    errors.push('Please enter a minimum of 1 file');
                }
            }

            addError(errors.length > 0, errors, this.props.sectionId, question.id);
        } else {
            if (question.response_required) {

                addError(true, ['Please enter a minimum of 1 file'], this.props.sectionId, question.id);
            }
        }
    }

    onFileDelete(file, func, index) {
        const { sectionId, blockId, question, onChange, getQuestionValue } = this.props;

        let value = getQuestionValue(sectionId, blockId, question.id);

        value = this.state.files.filter((_, i) => {
            return i !== index;
        });

        this.setState({ files: value }, () => {

        })

        onChange({ value });
        this.setError(value);

    }


    hasReachedMaxFileUpload() {
        const { question } = this.props;

        if(question.hasOwnProperty('max_upload_amount') === false) {
            return false;
        }
        if(question.max_upload_amount !== null) {
            return this.state.files.length === Number(question.max_upload_amount);
        }

        return  false;
    }

    addFile() {

         if(this.hasReachedMaxFileUpload()) {
             return;
         }

        this.setState({ files: [ ...this.state.files, {} ]});
    }

    render() {
        let { question, applicationId, params, showErrors, error } = this.props;

        return (
            <div className="section-content__container">
                { params.label && <p className="section-content__label">{ params.label }</p> }
                { params.description && <p className="section-content__label" dangerouslySetInnerHTML={{ __html: params.description }}></p> }

                <div className="document-upload__content">
                    { this.state.files.map((file, index) => {
                        params.value = Object.keys(file).length > 0 ? file : null;

                        return <>
                            <FileUpload
                                key={index}

                                onChange={(e) => this.onComponentChange(e, index)}
                                            onFileDelete={(func) => this.onFileDelete(file, func, index)}
                                            path={`/applications/${applicationId}/files`}
                                            questionId={question.id}
                                            applicationId={applicationId}
                                            params={{question_id: question.id}}
                                            { ...params }
                            />
                        </>

                        })
                    }

                    { this.hasReachedMaxFileUpload() === false
                        && <AddButton onClick={this.addFile.bind(this)} mobile={true}/>
                    }
                </div>

                { showErrors && error.length > 0 &&
                    <div className="section-content__errors">
                        { error.map(err => <p className="section-content__error">{ err }</p>)}
                    </div>
                }
            </div>
        )
    }
}
